import CrudModel from 'model-fns';
import Effects from '../../effects';
var crudModel = CrudModel('campaignID');
import xtend from 'xtend';

function CampaignModel (api) {
    function model () {
        return crudModel();
    }

    model.effects = Effects({
        get: api.vast.get
    });

    model.update = xtend(crudModel.update, {
        get: function (state, ev) {
            return crudModel.update.get(state, ev || []);
        }
    });

    return model;
}

export default CampaignModel;
